import {useEffect} from 'react';

import {
    useNavigate,
    useParams
} from 'react-router-dom';

import {Grid, Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';
import {PipelineStagesPanel} from '../profile/PipelineStagesPanel';
import {DeploymentAccountsPanel} from '../profile/DeploymentAccountsPanel';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {usePipeline} from '../hooks/usePipeline.ts';
import {usePipelinesSelection} from '../hooks/usePipelinesSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {StackStatusPanel} from '../components/StackStatusPanel';
import {useVerifiedPermissions} from '../../../../hooks/useVerifiedPermissions';
import {useOnUpdatePipelineSubscription} from '../hooks/useOnUpdatePipelineSubscription';


export const EditPage = () => {

    const {id: pipelineId} = useParams();

    if (typeof pipelineId === 'undefined') {
        throw new Error('pipelineId is required parameter');
    }

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`/pipelines/${pipelineId}`);
    }

    const {
        record: pipeline,
        updateRecord,
    } = usePipeline(pipelineId);

    const {handleClearSelection} = usePipelinesSelection();

    const {
        mode,
        tools,
    } = useEditPageTools(pipeline);

    const {allowedActions} = useVerifiedPermissions();
    const canViewStackStatus = allowedActions.includes('GetStackStatus');

    useOnUpdatePipelineSubscription();


    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);

    if (!pipeline) {
        return <PlatformLoader message='Loading pipeline...Please wait'/>;
    }

    return (
        <FormPageLayout
            title={pipeline.name ? pipeline.name : pipeline.id}
            pageNavigation={<EditPageNavigation component={pipeline}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 6
                    }}>
                        <Profile record={pipeline}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 6
                    }}>
                        <Stack gap='xl'>
                            {canViewStackStatus && pipeline.stackName && (
                                <StackStatusPanel stackName={pipeline.stackName}/>
                            )}
                            <PipelineStagesPanel record={pipeline}/>
                            <DeploymentAccountsPanel record={pipeline}/>
                        </Stack>
                    </Grid.Col>
                </Grid>

                :
                <RecordForm
                    record={pipeline}
                    handleSubmit={updateRecord}
                    handleCancel={onCancel}
                />}


        </FormPageLayout>
    );
};
